/**
 * Client-side permission checks aligned with backend rbac.config effective permissions.
 */

export const ADMIN_PANEL_ROLES = ['super_admin', 'admin', 'moderator'] as const

export type AdminPanelRole = (typeof ADMIN_PANEL_ROLES)[number]

export function isAdminPanelRole(role: string | undefined): role is AdminPanelRole {
  return !!role && (ADMIN_PANEL_ROLES as readonly string[]).includes(role)
}

export function hasAdminPermission(
  permissions: string[] | undefined,
  required: string,
): boolean {
  if (!permissions?.length) return false
  if (permissions.includes('*')) return true
  return permissions.includes(required)
}

export const ADMIN_NAV_PERMISSIONS: Record<string, string | undefined> = {
  '/admin/dashboard': 'analytics:read',
  '/admin/users': 'users:read',
  '/admin/brands': 'content:write',
  '/admin/cigar-lines': 'content:write',
  '/admin/catalog-health': 'content:read',
  '/admin/subscriptions': 'subscriptions:read',
  '/admin/backups': 'users:read',
  '/admin/content': 'content:write',
  '/admin/submissions': 'content:read',
  '/admin/moderation': 'content:read',
  '/admin/feedback': 'support:read',
  '/admin/audit-logs': 'system:logs',
  '/admin/roles': 'users:read',
  '/admin/settings': 'system:config',
  '/admin/integrations': 'system:integrations',
}
